import React, { useEffect } from 'react';
import doctor from '../../images/Capture4.PNG'
import doctor2 from '../../images/dental.png'
import doctor3 from '../../images/drug-dental.PNG'
import Aos from 'aos';
import 'aos/dist/aos.css';

const DentalCare = () => {
    useEffect(() => {
        Aos.init()
    })
    return (
        <div 
        data-aos="zoom-in"
        data-aos-duration="3000"
        className="bg-gray-300 ">
           <h1 className="text-4xl font-semibold text-red-500">Dental Clinic</h1>
           <div className="grid lg:grid-cols-3 px-5 mt-3">
               <div >
                   <img className="px-3" src={doctor} alt="" />
               </div>
               <div>
                   <img className="px-3" src={doctor2} alt="" />
               </div>
               <div>
                   <img className="px-3" src={doctor3} alt="" />
               </div>
           </div>

           <div className="mt-10">
               
               <p className="text-justify text-xl px-10  mb-5"> A full-stack single-page dental care web app. Login system with firebase and private routes. Users can book doctors appointment. </p>
               
               <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Tailwind</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">React Router</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Private Route</button>
        
        <button className="px-2 py-1 bg-gray-400 mx-1">Firebase Authentication</button>
           </div>

           <div className="mt-5 pb-10"> 
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://dental-care-b48a7.web.app/">Live Preview</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://github.com/Joy10311/Dental-Clinic"> Code Link</a> </button>
           </div>
        </div>
    );
};

export default DentalCare;